interface SizeProps {
  size?: number;
}

export function ArrowDown({ size = 24 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2797 5.96667L8.93306 10.3133C8.41973 10.8267 7.57973 10.8267 7.06639 10.3133L2.71973 5.96667"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function FilterIcon({ size = 24 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.667 4.33337H10.667"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.99967 4.33337H1.33301"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66634 6.66667C7.95501 6.66667 8.99967 5.622 8.99967 4.33333C8.99967 3.04467 7.95501 2 6.66634 2C5.37768 2 4.33301 3.04467 4.33301 4.33333C4.33301 5.622 5.37768 6.66667 6.66634 6.66667Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6667 11.6666H12"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.33301 11.6666H1.33301"
        stroke="#7A7A7A"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33333 14C10.622 14 11.6667 12.9554 11.6667 11.6667C11.6667 10.378 10.622 9.33337 9.33333 9.33337C8.04467 9.33337 7 10.378 7 11.6667C7 12.9554 8.04467 14 9.33333 14Z"
        stroke="#7A7A7A"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function UserIcon({ size }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.63216 10.1834C7.60716 10.1834 7.5905 10.1834 7.5655 10.1834C7.52383 10.1751 7.46549 10.1751 7.41549 10.1834C4.99883 10.1084 3.17383 8.20841 3.17383 5.86675C3.17383 3.48341 5.11549 1.54175 7.49883 1.54175C9.88216 1.54175 11.8238 3.48341 11.8238 5.86675C11.8155 8.20841 9.98216 10.1084 7.65716 10.1834C7.64883 10.1834 7.64049 10.1834 7.63216 10.1834ZM7.49883 2.79175C5.80716 2.79175 4.42383 4.17508 4.42383 5.86675C4.42383 7.53341 5.72383 8.87508 7.38216 8.93341C7.43216 8.92508 7.5405 8.92508 7.64883 8.93341C9.28216 8.85841 10.5655 7.51675 10.5738 5.86675C10.5738 4.17508 9.1905 2.79175 7.49883 2.79175Z"
        fill="currentColor"
      />
      <path
        d="M13.784 10.2916C13.759 10.2916 13.734 10.2916 13.709 10.2833C13.3673 10.3166 13.0173 10.0749 12.984 9.73325C12.9506 9.39159 13.159 9.08325 13.5006 9.04159C13.6006 9.03325 13.709 9.03325 13.8006 9.03325C15.0173 8.96659 15.9673 7.96659 15.9673 6.74159C15.9673 5.47492 14.9423 4.44992 13.6756 4.44992C13.334 4.45825 13.0506 4.17492 13.0506 3.83325C13.0506 3.49159 13.334 3.20825 13.6756 3.20825C15.6256 3.20825 17.2173 4.79992 17.2173 6.74992C17.2173 8.66659 15.7173 10.2166 13.809 10.2916C13.8006 10.2916 13.7923 10.2916 13.784 10.2916Z"
        fill="currentColor"
      />
      <path
        d="M7.64036 19.2916C6.00703 19.2916 4.36536 18.8749 3.1237 18.0416C1.96536 17.2749 1.33203 16.2249 1.33203 15.0833C1.33203 13.9416 1.96536 12.8833 3.1237 12.1083C5.6237 10.4499 9.6737 10.4499 12.157 12.1083C13.307 12.8749 13.9487 13.9249 13.9487 15.0666C13.9487 16.2083 13.3154 17.2666 12.157 18.0416C10.907 18.8749 9.2737 19.2916 7.64036 19.2916ZM3.81536 13.1583C3.01536 13.6916 2.58203 14.3749 2.58203 15.0916C2.58203 15.7999 3.0237 16.4833 3.81536 17.0083C5.89036 18.3999 9.39036 18.3999 11.4654 17.0083C12.2654 16.4749 12.6987 15.7916 12.6987 15.0749C12.6987 14.3666 12.257 13.6833 11.4654 13.1583C9.39036 11.7749 5.89036 11.7749 3.81536 13.1583Z"
        fill="currentColor"
      />
      <path
        d="M15.2825 17.7917C14.9908 17.7917 14.7325 17.5917 14.6742 17.2917C14.6075 16.95 14.8242 16.625 15.1575 16.55C15.6825 16.4417 16.1658 16.2333 16.5408 15.9417C17.0158 15.5833 17.2742 15.1333 17.2742 14.6583C17.2742 14.1833 17.0158 13.7333 16.5492 13.3833C16.1825 13.1 15.7242 12.9 15.1825 12.775C14.8492 12.7 14.6325 12.3667 14.7075 12.025C14.7825 11.6917 15.1158 11.475 15.4575 11.55C16.1742 11.7083 16.7992 11.9917 17.3075 12.3833C18.0825 12.9667 18.5242 13.7917 18.5242 14.6583C18.5242 15.525 18.0742 16.35 17.2992 16.9417C16.7825 17.3417 16.1325 17.6333 15.4158 17.775C15.3658 17.7917 15.3242 17.7917 15.2825 17.7917Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function StatusIcon({ size = 24 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.63379 9.97998C2.34712 12.2733 4.26713 14.04 6.65379 14.5266"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.36621 7.32004C1.70621 3.95337 4.54621 1.33337 7.99954 1.33337C11.4529 1.33337 14.2929 3.96004 14.6329 7.32004"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33984 14.5333C11.7198 14.0466 13.6332 12.3 14.3598 10.0133"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CalendarIcon({ size = 24 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33301 1.33337V3.33337"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.667 1.33337V3.33337"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.33301 6.06006H13.6663"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 5.66671V11.3334C14 13.3334 13 14.6667 10.6667 14.6667H5.33333C3 14.6667 2 13.3334 2 11.3334V5.66671C2 3.66671 3 2.33337 5.33333 2.33337H10.6667C13 2.33337 14 3.66671 14 5.66671Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.4635 9.13338H10.4694"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.4635 11.1334H10.4694"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99666 9.13338H8.00265"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99666 11.1334H8.00265"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.52987 9.13338H5.53585"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.52987 11.1334H5.53585"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function TeamsIcon({ size = 24 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.10671 7.24671C6.04004 7.24004 5.96004 7.24004 5.88671 7.24671C4.30004 7.19337 3.04004 5.89337 3.04004 4.29337C3.04004 2.66004 4.36004 1.33337 6.00004 1.33337C7.63337 1.33337 8.96004 2.66004 8.96004 4.29337C8.95337 5.89337 7.69337 7.19337 6.10671 7.24671Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.9402 2.66663C12.2335 2.66663 13.2735 3.71329 13.2735 4.99996C13.2735 6.25996 12.2735 7.28663 11.0268 7.33329C10.9735 7.32663 10.9135 7.32663 10.8535 7.33329"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.77348 9.70663C1.16014 10.7866 1.16014 12.5466 2.77348 13.62C4.60681 14.8466 7.61348 14.8466 9.44681 13.62C11.0601 12.54 11.0601 10.78 9.44681 9.70663C7.62014 8.48663 4.61348 8.48663 2.77348 9.70663Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.2266 13.3334C12.7066 13.2334 13.1599 13.04 13.5332 12.7534C14.5732 11.9734 14.5732 10.6867 13.5332 9.90671C13.1666 9.62671 12.7199 9.44004 12.2466 9.33337"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function PriorityIcon({ size = 24 }: SizeProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 14.6667H14"
        stroke="#7A7A7A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.73332 5.58667H2.66667C2.3 5.58667 2 5.88667 2 6.25334V12C2 12.3667 2.3 12.6667 2.66667 12.6667H3.73332C4.09998 12.6667 4.39998 12.3667 4.39998 12V6.25334C4.39998 5.88667 4.09998 5.58667 3.73332 5.58667Z"
        stroke="#7A7A7A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.53312 3.45996H7.46647C7.0998 3.45996 6.7998 3.75996 6.7998 4.12663V12C6.7998 12.3666 7.0998 12.6666 7.46647 12.6666H8.53312C8.89979 12.6666 9.19979 12.3666 9.19979 12V4.12663C9.19979 3.75996 8.89979 3.45996 8.53312 3.45996Z"
        stroke="#7A7A7A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3339 1.33331H12.2673C11.9006 1.33331 11.6006 1.63331 11.6006 1.99998V12C11.6006 12.3666 11.9006 12.6666 12.2673 12.6666H13.3339C13.7006 12.6666 14.0006 12.3666 14.0006 12V1.99998C14.0006 1.63331 13.7006 1.33331 13.3339 1.33331Z"
        stroke="#7A7A7A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function EllipsesIcon({
  size = 24,
  orientation = 'horizontal',
}: {
  size?: number;
  orientation?: string;
}) {
  if (orientation === 'vertical') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 5C14 3.9 13.1 3 12 3C10.9 3 10 3.9 10 5C10 6.1 10.9 7 12 7C13.1 7 14 6.1 14 5Z"
          fill="#7A7A7A"
        />
        <path
          d="M14 19C14 17.9 13.1 17 12 17C10.9 17 10 17.9 10 19C10 20.1 10.9 21 12 21C13.1 21 14 20.1 14 19Z"
          fill="#7A7A7A"
        />
        <path
          d="M14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12Z"
          fill="#7A7A7A"
        />
      </svg>
    );
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16667 8.33337C3.25 8.33337 2.5 9.08337 2.5 10C2.5 10.9167 3.25 11.6667 4.16667 11.6667C5.08333 11.6667 5.83333 10.9167 5.83333 10C5.83333 9.08337 5.08333 8.33337 4.16667 8.33337Z"
        fill="#7A7A7A"
      />
      <path
        d="M15.8337 8.33337C14.917 8.33337 14.167 9.08337 14.167 10C14.167 10.9167 14.917 11.6667 15.8337 11.6667C16.7503 11.6667 17.5003 10.9167 17.5003 10C17.5003 9.08337 16.7503 8.33337 15.8337 8.33337Z"
        fill="#7A7A7A"
      />
      <path
        d="M9.99967 8.33337C9.08301 8.33337 8.33301 9.08337 8.33301 10C8.33301 10.9167 9.08301 11.6667 9.99967 11.6667C10.9163 11.6667 11.6663 10.9167 11.6663 10C11.6663 9.08337 10.9163 8.33337 9.99967 8.33337Z"
        fill="#7A7A7A"
      />
    </svg>
  );
}

export function ChevronRight({ size = 16 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.94043 13.28L10.2871 8.93333C10.8004 8.42 10.8004 7.58 10.2871 7.06667L5.94043 2.72"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ExpandIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 7.5V2.5H12.5"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 12.5V17.5H7.5"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 2.5L11.25 8.75"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.75 11.25L2.5 17.5"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function Comment() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.795 6.2V8.235C7.795 8.415 7.775 8.585 7.73 8.74C7.545 9.475 6.935 9.935 6.095 9.935H4.735L3.225 10.94C3 11.095 2.7 10.93 2.7 10.66V9.935C2.19 9.935 1.765 9.765 1.47 9.47C1.17 9.17 1 8.745 1 8.235V6.2C1 5.25 1.59 4.595 2.5 4.51C2.565 4.505 2.63 4.5 2.7 4.5H6.095C7.115 4.5 7.795 5.18 7.795 6.2Z"
        fill="currentColor"
      />
      <path
        d="M4.625 1.25H8.875C9.91193 1.25 10.75 2.08807 10.75 3.125V5.6748C10.75 6.25421 10.5592 6.72147 10.2393 7.03711L10.2373 7.03906C9.92166 7.35897 9.45441 7.5498 8.875 7.5498H8.79492V6.2002C8.79492 4.70712 7.5878 3.5 6.09473 3.5H2.75V3.125C2.75 2.08807 3.58807 1.25 4.625 1.25Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.5"
      />
    </svg>
  );
}

export function FileIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 11.375H4.5C1.785 11.375 0.625 10.215 0.625 7.5V4.5C0.625 1.785 1.785 0.625 4.5 0.625H7C7.205 0.625 7.375 0.795 7.375 1C7.375 1.205 7.205 1.375 7 1.375H4.5C2.195 1.375 1.375 2.195 1.375 4.5V7.5C1.375 9.805 2.195 10.625 4.5 10.625H7.5C9.805 10.625 10.625 9.805 10.625 7.5V5C10.625 4.795 10.795 4.625 11 4.625C11.205 4.625 11.375 4.795 11.375 5V7.5C11.375 10.215 10.215 11.375 7.5 11.375Z"
        fill="currentColor"
      />
      <path
        d="M11 5.37499H9C7.29 5.37499 6.625 4.70999 6.625 2.99999V0.999994C6.625 0.849994 6.715 0.709994 6.855 0.654994C6.995 0.594994 7.155 0.629994 7.265 0.734994L11.265 4.73499C11.37 4.83999 11.405 5.00499 11.345 5.14499C11.285 5.28499 11.15 5.37499 11 5.37499ZM7.375 1.90499V2.99999C7.375 4.28999 7.71 4.62499 9 4.62499H10.095L7.375 1.90499Z"
        fill="currentColor"
      />
      <path
        d="M3.5 6.375H6.5C6.56693 6.375 6.625 6.43307 6.625 6.5C6.625 6.56693 6.56693 6.625 6.5 6.625H3.5C3.43307 6.625 3.375 6.56693 3.375 6.5C3.375 6.43307 3.43307 6.375 3.5 6.375Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.5"
      />
      <path
        d="M5.5 8.875H3.5C3.295 8.875 3.125 8.705 3.125 8.5C3.125 8.295 3.295 8.125 3.5 8.125H5.5C5.705 8.125 5.875 8.295 5.875 8.5C5.875 8.705 5.705 8.875 5.5 8.875Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LinkIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.53562 7.12005C9.39062 7.26505 9.16062 7.26505 9.02062 7.12005C8.87562 6.97505 8.87562 6.74505 9.02062 6.60505C10.0206 5.60505 10.0206 3.98005 9.02062 2.98505C8.02062 1.99005 6.39562 1.98505 5.40062 2.98505C4.40562 3.98505 4.40062 5.61005 5.40062 6.60505C5.54562 6.75005 5.54562 6.98005 5.40062 7.12005C5.25562 7.26505 5.02562 7.26505 4.88562 7.12005C3.60063 5.83505 3.60063 3.74505 4.88562 2.46505C6.17062 1.18505 8.26062 1.18005 9.54062 2.46505C10.8206 3.75005 10.8206 5.83505 9.53562 7.12005Z"
        fill="currentColor"
      />
      <path
        d="M2.46438 4.87999C2.60938 4.73499 2.83938 4.73499 2.97938 4.87999C3.12438 5.02499 3.12438 5.25499 2.97938 5.39499C1.97938 6.39499 1.97938 8.01999 2.97938 9.01499C3.97938 10.01 5.60438 10.015 6.59938 9.01499C7.59438 8.01499 7.59938 6.38999 6.59938 5.39499C6.45438 5.24999 6.45438 5.01999 6.59938 4.87999C6.74438 4.73499 6.97438 4.73499 7.11438 4.87999C8.39937 6.16499 8.39937 8.25499 7.11438 9.53499C5.82938 10.815 3.73938 10.82 2.45938 9.53499C1.17938 8.24999 1.17938 6.16499 2.46438 4.87999Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LinkIcon2() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9998 12.1667H9.99316C9.71983 12.1667 9.49316 11.94 9.49316 11.6667C9.49316 11.3934 9.71983 11.1667 9.99316 11.1667H10.9998C12.7465 11.1667 14.1665 9.7467 14.1665 8.00004C14.1665 6.25337 12.7465 4.83337 10.9998 4.83337H9.99983C9.7265 4.83337 9.49983 4.60671 9.49983 4.33337C9.49983 4.06004 9.71983 3.83337 9.99983 3.83337H10.9998C13.2998 3.83337 15.1665 5.70004 15.1665 8.00004C15.1665 10.3 13.2998 12.1667 10.9998 12.1667Z"
        fill="currentColor"
      />
      <path
        d="M5.99967 12.1667H4.99967C2.69967 12.1667 0.833008 10.3 0.833008 8.00004C0.833008 5.70004 2.69967 3.83337 4.99967 3.83337H5.99967C6.27301 3.83337 6.49967 4.06004 6.49967 4.33337C6.49967 4.60671 6.27301 4.83337 5.99967 4.83337H4.99967C3.25301 4.83337 1.83301 6.25337 1.83301 8.00004C1.83301 9.7467 3.25301 11.1667 4.99967 11.1667H5.99967C6.27301 11.1667 6.49967 11.3934 6.49967 11.6667C6.49967 11.94 6.27301 12.1667 5.99967 12.1667Z"
        fill="currentColor"
      />
      <path
        d="M10.6663 8.5H5.33301C5.05967 8.5 4.83301 8.27333 4.83301 8C4.83301 7.72667 5.05967 7.5 5.33301 7.5H10.6663C10.9397 7.5 11.1663 7.72667 11.1663 8C11.1663 8.27333 10.9397 8.5 10.6663 8.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AttachmentIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99967 15.1667H5.99967C2.37967 15.1667 0.833008 13.62 0.833008 10V6.00004C0.833008 2.38004 2.37967 0.833374 5.99967 0.833374H9.333C9.60634 0.833374 9.833 1.06004 9.833 1.33337C9.833 1.60671 9.60634 1.83337 9.333 1.83337H5.99967C2.92634 1.83337 1.83301 2.92671 1.83301 6.00004V10C1.83301 13.0734 2.92634 14.1667 5.99967 14.1667H9.99967C13.073 14.1667 14.1663 13.0734 14.1663 10V6.6667C14.1663 6.39337 14.393 6.1667 14.6663 6.1667C14.9397 6.1667 15.1663 6.39337 15.1663 6.6667V10C15.1663 13.62 13.6197 15.1667 9.99967 15.1667Z"
        fill="currentColor"
      />
      <path
        d="M14.6663 7.1667H11.9997C9.71967 7.1667 8.83301 6.28003 8.83301 4.00003V1.33337C8.83301 1.13337 8.95301 0.9467 9.13967 0.873366C9.32634 0.793366 9.53967 0.840033 9.68634 0.980033L15.0197 6.31336C15.1597 6.45336 15.2063 6.67336 15.1263 6.86003C15.0463 7.0467 14.8663 7.1667 14.6663 7.1667ZM9.83301 2.54003V4.00003C9.83301 5.72003 10.2797 6.1667 11.9997 6.1667H13.4597L9.83301 2.54003Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PlusIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 8.5H4C3.72667 8.5 3.5 8.27333 3.5 8C3.5 7.72667 3.72667 7.5 4 7.5H12C12.2733 7.5 12.5 7.72667 12.5 8C12.5 8.27333 12.2733 8.5 12 8.5Z"
        fill="currentColor"
      />
      <path
        d="M8 12.5C7.72667 12.5 7.5 12.2733 7.5 12V4C7.5 3.72667 7.72667 3.5 8 3.5C8.27333 3.5 8.5 3.72667 8.5 4V12C8.5 12.2733 8.27333 12.5 8 12.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ShareIcon({ size }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1055 4.03989C12.415 4.95001 13.3186 6.39703 13.5019 8.06667"
        stroke="currentColor"
        stroke-width="0.785714"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.28516 8.09939C2.45539 6.43629 3.34587 4.98927 4.6423 4.0726"
        stroke="currentColor"
        stroke-width="0.785714"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.3623 13.7107C6.12183 14.097 6.98611 14.313 7.89623 14.313C8.77361 14.313 9.59861 14.1166 10.3385 13.7565"
        stroke="currentColor"
        stroke-width="0.785714"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.89641 5.0416C8.9017 5.0416 9.71665 4.22665 9.71665 3.22136C9.71665 2.21607 8.9017 1.40112 7.89641 1.40112C6.89112 1.40112 6.07617 2.21607 6.07617 3.22136C6.07617 4.22665 6.89112 5.0416 7.89641 5.0416Z"
        stroke="currentColor"
        stroke-width="0.785714"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.16204 13.0429C4.16733 13.0429 4.98227 12.2279 4.98227 11.2226C4.98227 10.2173 4.16733 9.40237 3.16204 9.40237C2.15675 9.40237 1.3418 10.2173 1.3418 11.2226C1.3418 12.2279 2.15675 13.0429 3.16204 13.0429Z"
        stroke="currentColor"
        stroke-width="1.17857"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5517 13.0429C13.557 13.0429 14.3719 12.228 14.3719 11.2227C14.3719 10.2174 13.557 9.40247 12.5517 9.40247C11.5464 9.40247 10.7314 10.2174 10.7314 11.2227C10.7314 12.228 11.5464 13.0429 12.5517 13.0429Z"
        stroke="currentColor"
        stroke-width="1.17857"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function InfoIcon({ size }: SizeProps = {}) {
  return (
    <svg
      width={size ?? '100%'}
      height={size ?? '100%'}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11C8.75 11 11 8.75 11 6C11 3.25 8.75 1 6 1C3.25 1 1 3.25 1 6C1 8.75 3.25 11 6 11Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 4V6.5"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.99707 8H6.00156"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function DownloadIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.91984 9.99333C7.79318 9.99333 7.66651 9.94666 7.56651 9.84666L5.85984 8.14C5.66651 7.94666 5.66651 7.62666 5.85984 7.43333C6.05318 7.24 6.37318 7.24 6.56651 7.43333L7.91984 8.78666L9.27318 7.43333C9.46651 7.24 9.78651 7.24 9.97984 7.43333C10.1732 7.62666 10.1732 7.94666 9.97984 8.14L8.27318 9.84666C8.17318 9.94666 8.04651 9.99333 7.91984 9.99333Z"
        fill="currentColor"
      />
      <path
        d="M7.91992 9.94668C7.64659 9.94668 7.41992 9.72002 7.41992 9.44668V2.66669C7.41992 2.39335 7.64659 2.16669 7.91992 2.16669C8.19325 2.16669 8.41992 2.39335 8.41992 2.66669V9.44668C8.41992 9.72002 8.19325 9.94668 7.91992 9.94668Z"
        fill="currentColor"
      />
      <path
        d="M8.00032 13.9533C4.56699 13.9533 2.16699 11.5533 2.16699 8.11999C2.16699 7.84666 2.39366 7.62 2.66699 7.62C2.94033 7.62 3.16699 7.84666 3.16699 8.11999C3.16699 10.9667 5.15366 12.9533 8.00032 12.9533C10.847 12.9533 12.8337 10.9667 12.8337 8.11999C12.8337 7.84666 13.0603 7.62 13.3337 7.62C13.607 7.62 13.8337 7.84666 13.8337 8.11999C13.8337 11.5533 11.4337 13.9533 8.00032 13.9533Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CommandIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 8.375H4C3.795 8.375 3.625 8.205 3.625 8V4C3.625 3.795 3.795 3.625 4 3.625H8C8.205 3.625 8.375 3.795 8.375 4V8C8.375 8.205 8.205 8.375 8 8.375ZM4.375 7.625H7.625V4.375H4.375V7.625Z"
        fill="currentColor"
      />
      <path
        d="M2.5 11.375C1.465 11.375 0.625 10.535 0.625 9.5C0.625 8.465 1.465 7.625 2.5 7.625H4C4.205 7.625 4.375 7.795 4.375 8V9.5C4.375 10.535 3.535 11.375 2.5 11.375ZM2.5 8.375C1.88 8.375 1.375 8.88 1.375 9.5C1.375 10.12 1.88 10.625 2.5 10.625C3.12 10.625 3.625 10.12 3.625 9.5V8.375H2.5Z"
        fill="currentColor"
      />
      <path
        d="M4 4.375H2.5C1.465 4.375 0.625 3.535 0.625 2.5C0.625 1.465 1.465 0.625 2.5 0.625C3.535 0.625 4.375 1.465 4.375 2.5V4C4.375 4.205 4.205 4.375 4 4.375ZM2.5 1.375C1.88 1.375 1.375 1.88 1.375 2.5C1.375 3.12 1.88 3.625 2.5 3.625H3.625V2.5C3.625 1.88 3.12 1.375 2.5 1.375Z"
        fill="currentColor"
      />
      <path
        d="M9.5 4.375H8C7.795 4.375 7.625 4.205 7.625 4V2.5C7.625 1.465 8.465 0.625 9.5 0.625C10.535 0.625 11.375 1.465 11.375 2.5C11.375 3.535 10.535 4.375 9.5 4.375ZM8.375 3.625H9.5C10.12 3.625 10.625 3.12 10.625 2.5C10.625 1.88 10.12 1.375 9.5 1.375C8.88 1.375 8.375 1.88 8.375 2.5V3.625Z"
        fill="currentColor"
      />
      <path
        d="M9.5 11.375C8.465 11.375 7.625 10.535 7.625 9.5V8C7.625 7.795 7.795 7.625 8 7.625H9.5C10.535 7.625 11.375 8.465 11.375 9.5C11.375 10.535 10.535 11.375 9.5 11.375ZM8.375 8.375V9.5C8.375 10.12 8.88 10.625 9.5 10.625C10.12 10.625 10.625 10.12 10.625 9.5C10.625 8.88 10.12 8.375 9.5 8.375H8.375Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Profile() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6663 8.00004C14.6663 4.32671 11.673 1.33337 7.99967 1.33337C4.32634 1.33337 1.33301 4.32671 1.33301 8.00004C1.33301 9.93337 2.16634 11.6734 3.48634 12.8934C3.48634 12.9 3.48634 12.9 3.47967 12.9067C3.54634 12.9734 3.62634 13.0267 3.69301 13.0867C3.73301 13.12 3.76634 13.1534 3.80634 13.18C3.92634 13.28 4.05967 13.3734 4.18634 13.4667C4.23301 13.5 4.27301 13.5267 4.31967 13.56C4.44634 13.6467 4.57967 13.7267 4.71967 13.8C4.76634 13.8267 4.81967 13.86 4.86634 13.8867C4.99967 13.96 5.13967 14.0267 5.28634 14.0867C5.33967 14.1134 5.39301 14.14 5.44634 14.16C5.59301 14.22 5.73967 14.2734 5.88634 14.32C5.93967 14.34 5.99301 14.36 6.04634 14.3734C6.20634 14.42 6.36634 14.46 6.52634 14.5C6.57301 14.5134 6.61967 14.5267 6.67301 14.5334C6.85967 14.5734 7.04634 14.6 7.23967 14.62C7.26634 14.62 7.29301 14.6267 7.31967 14.6334C7.54634 14.6534 7.77301 14.6667 7.99967 14.6667C8.22634 14.6667 8.45301 14.6534 8.67301 14.6334C8.69968 14.6334 8.72634 14.6267 8.75301 14.62C8.94634 14.6 9.13301 14.5734 9.31967 14.5334C9.36634 14.5267 9.41301 14.5067 9.46634 14.5C9.62634 14.46 9.79301 14.4267 9.94634 14.3734C9.99967 14.3534 10.053 14.3334 10.1063 14.32C10.253 14.2667 10.4063 14.22 10.5463 14.16C10.5997 14.14 10.653 14.1134 10.7063 14.0867C10.8463 14.0267 10.9863 13.96 11.1263 13.8867C11.1797 13.86 11.2263 13.8267 11.273 13.8C11.4063 13.72 11.5397 13.6467 11.673 13.56C11.7197 13.5334 11.7597 13.5 11.8063 13.4667C11.9397 13.3734 12.0663 13.28 12.1863 13.18C12.2263 13.1467 12.2597 13.1134 12.2997 13.0867C12.373 13.0267 12.4463 12.9667 12.513 12.9067C12.513 12.9 12.513 12.9 12.5063 12.8934C13.833 11.6734 14.6663 9.93337 14.6663 8.00004ZM11.293 11.3134C9.48634 10.1 6.52634 10.1 4.70634 11.3134C4.41301 11.5067 4.17301 11.7334 3.97301 11.98C2.95967 10.9534 2.33301 9.54671 2.33301 8.00004C2.33301 4.87337 4.87301 2.33337 7.99967 2.33337C11.1263 2.33337 13.6663 4.87337 13.6663 8.00004C13.6663 9.54671 13.0397 10.9534 12.0263 11.98C11.833 11.7334 11.5863 11.5067 11.293 11.3134Z"
        fill="currentColor"
      />
      <path
        d="M8 4.62C6.62 4.62 5.5 5.74 5.5 7.12C5.5 8.47333 6.56 9.57333 7.96667 9.61333C7.98667 9.61333 8.01333 9.61333 8.02667 9.61333C8.04 9.61333 8.06 9.61333 8.07333 9.61333C8.08 9.61333 8.08667 9.61333 8.08667 9.61333C9.43333 9.56666 10.4933 8.47333 10.5 7.12C10.5 5.74 9.38 4.62 8 4.62Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EditIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.69332 13.0133C3.28666 13.0133 2.90666 12.8733 2.63332 12.6133C2.28666 12.2867 2.11999 11.7933 2.17999 11.26L2.42666 9.09999C2.47332 8.69333 2.71999 8.15333 3.00666 7.85999L8.47999 2.06666C9.84666 0.619992 11.2733 0.579992 12.72 1.94666C14.1667 3.31333 14.2067 4.73999 12.84 6.18666L7.36666 11.98C7.08666 12.28 6.56666 12.56 6.15999 12.6267L4.01332 12.9933C3.89999 13 3.79999 13.0133 3.69332 13.0133ZM10.62 1.93999C10.1067 1.93999 9.65999 2.25999 9.20666 2.73999L3.73332 8.53999C3.59999 8.67999 3.44666 9.01333 3.41999 9.20666L3.17332 11.3667C3.14666 11.5867 3.19999 11.7667 3.31999 11.88C3.43999 11.9933 3.61999 12.0333 3.83999 12L5.98666 11.6333C6.17999 11.6 6.49999 11.4267 6.63332 11.2867L12.1067 5.49333C12.9333 4.61333 13.2333 3.79999 12.0267 2.66666C11.4933 2.15333 11.0333 1.93999 10.62 1.93999Z"
        fill="currentColor"
      />
      <path
        d="M11.56 7.29998C11.5466 7.29998 11.5266 7.29998 11.5133 7.29998C9.4333 7.09331 7.75996 5.51331 7.43996 3.44665C7.39996 3.17331 7.58663 2.91998 7.85996 2.87331C8.1333 2.83331 8.38663 3.01998 8.4333 3.29331C8.68663 4.90665 9.9933 6.14665 11.62 6.30665C11.8933 6.33331 12.0933 6.57998 12.0666 6.85331C12.0333 7.10665 11.8133 7.29998 11.56 7.29998Z"
        fill="currentColor"
      />
      <path
        d="M14 15.1667H2C1.72667 15.1667 1.5 14.94 1.5 14.6667C1.5 14.3933 1.72667 14.1667 2 14.1667H14C14.2733 14.1667 14.5 14.3933 14.5 14.6667C14.5 14.94 14.2733 15.1667 14 15.1667Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function BugFixIcon({ size = 20 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.458 8.75C10.7663 8.75 10.208 8.19167 10.208 7.5C10.208 6.80833 10.7663 6.25 11.458 6.25C12.1497 6.25 12.708 6.80833 12.708 7.5C12.708 8.19167 12.1497 8.75 11.458 8.75ZM11.458 7.08333C11.2247 7.08333 11.0413 7.26667 11.0413 7.5C11.0413 7.73333 11.2247 7.91667 11.458 7.91667C11.6913 7.91667 11.8747 7.73333 11.8747 7.5C11.8747 7.26667 11.6913 7.08333 11.458 7.08333Z"
        fill="currentColor"
      />
      <path
        d="M8.54199 8.75C7.85033 8.75 7.29199 8.19167 7.29199 7.5C7.29199 6.80833 7.85033 6.25 8.54199 6.25C9.23366 6.25 9.79199 6.80833 9.79199 7.5C9.79199 8.19167 9.23366 8.75 8.54199 8.75ZM8.54199 7.08333C8.30866 7.08333 8.12533 7.26667 8.12533 7.5C8.12533 7.73333 8.30866 7.91667 8.54199 7.91667C8.77533 7.91667 8.95866 7.73333 8.95866 7.5C8.95866 7.26667 8.77533 7.08333 8.54199 7.08333Z"
        fill="currentColor"
      />
      <path
        d="M12.917 11.25C12.2253 11.25 11.667 10.6917 11.667 10C11.667 9.30833 12.2253 8.75 12.917 8.75C13.6087 8.75 14.167 9.30833 14.167 10C14.167 10.6917 13.6087 11.25 12.917 11.25ZM12.917 9.58333C12.6837 9.58333 12.5003 9.76667 12.5003 10C12.5003 10.2333 12.6837 10.4167 12.917 10.4167C13.1503 10.4167 13.3337 10.2333 13.3337 10C13.3337 9.76667 13.1503 9.58333 12.917 9.58333Z"
        fill="currentColor"
      />
      <path
        d="M14.2917 8.54168C13.7167 8.54168 13.25 8.07501 13.25 7.50001C13.25 6.92501 13.7167 6.45834 14.2917 6.45834C14.8667 6.45834 15.3333 6.92501 15.3333 7.50001C15.3333 8.07501 14.8667 8.54168 14.2917 8.54168ZM14.2917 7.29168C14.175 7.29168 14.0833 7.38334 14.0833 7.50001C14.0833 7.73334 14.5 7.73334 14.5 7.50001C14.5 7.38334 14.4083 7.29168 14.2917 7.29168Z"
        fill="currentColor"
      />
      <path
        d="M14.2917 13.5417C13.7167 13.5417 13.25 13.075 13.25 12.5C13.25 11.925 13.7167 11.4583 14.2917 11.4583C14.8667 11.4583 15.3333 11.925 15.3333 12.5C15.3333 13.075 14.8667 13.5417 14.2917 13.5417ZM14.2917 12.2917C14.175 12.2917 14.0833 12.3833 14.0833 12.5C14.0833 12.7333 14.5 12.7333 14.5 12.5C14.5 12.3833 14.4083 12.2917 14.2917 12.2917Z"
        fill="currentColor"
      />
      <path
        d="M16.4587 11.0417C15.8837 11.0417 15.417 10.575 15.417 10C15.417 9.42501 15.8837 8.95834 16.4587 8.95834C17.0337 8.95834 17.5003 9.42501 17.5003 10C17.5003 10.575 17.0337 11.0417 16.4587 11.0417ZM16.4587 9.79168C16.342 9.79168 16.2503 9.88334 16.2503 10C16.2503 10.2333 16.667 10.2333 16.667 10C16.667 9.88334 16.5753 9.79168 16.4587 9.79168Z"
        fill="currentColor"
      />
      <path
        d="M5.66667 8.54168C5.09167 8.54168 4.625 8.07501 4.625 7.50001C4.625 6.92501 5.09167 6.45834 5.66667 6.45834C6.24167 6.45834 6.70833 6.92501 6.70833 7.50001C6.70833 8.07501 6.24167 8.54168 5.66667 8.54168ZM5.66667 7.29168C5.55 7.29168 5.45833 7.38334 5.45833 7.50001C5.45833 7.73334 5.875 7.73334 5.875 7.50001C5.875 7.38334 5.78333 7.29168 5.66667 7.29168Z"
        fill="currentColor"
      />
      <path
        d="M5.66667 13.5417C5.09167 13.5417 4.625 13.075 4.625 12.5C4.625 11.925 5.09167 11.4583 5.66667 11.4583C6.24167 11.4583 6.70833 11.925 6.70833 12.5C6.70833 13.075 6.24167 13.5417 5.66667 13.5417ZM5.66667 12.2917C5.55 12.2917 5.45833 12.3833 5.45833 12.5C5.45833 12.7333 5.875 12.7333 5.875 12.5C5.875 12.3833 5.78333 12.2917 5.66667 12.2917Z"
        fill="currentColor"
      />
      <path
        d="M3.49967 11.0417C2.92467 11.0417 2.45801 10.575 2.45801 10C2.45801 9.42501 2.92467 8.95834 3.49967 8.95834C4.07467 8.95834 4.54134 9.42501 4.54134 10C4.54134 10.575 4.07467 11.0417 3.49967 11.0417ZM3.49967 9.79168C3.38301 9.79168 3.29134 9.88334 3.29134 10C3.29134 10.2333 3.70801 10.2333 3.70801 10C3.70801 9.88334 3.61634 9.79168 3.49967 9.79168Z"
        fill="currentColor"
      />
      <path
        d="M13.2507 5.37496C12.6757 5.37496 12.209 4.90829 12.209 4.33329C12.209 3.75829 12.6757 3.29163 13.2507 3.29163C13.8257 3.29163 14.2923 3.75829 14.2923 4.33329C14.2923 4.90829 13.8257 5.37496 13.2507 5.37496ZM13.2507 4.12496C13.134 4.12496 13.0423 4.21663 13.0423 4.33329C13.0423 4.56663 13.459 4.56663 13.459 4.33329C13.459 4.21663 13.3673 4.12496 13.2507 4.12496Z"
        fill="currentColor"
      />
      <path
        d="M6.74967 5.37496C6.17467 5.37496 5.70801 4.90829 5.70801 4.33329C5.70801 3.75829 6.17467 3.29163 6.74967 3.29163C7.32467 3.29163 7.79134 3.75829 7.79134 4.33329C7.79134 4.90829 7.32467 5.37496 6.74967 5.37496ZM6.74967 4.12496C6.63301 4.12496 6.54134 4.21663 6.54134 4.33329C6.54134 4.56663 6.95801 4.56663 6.95801 4.33329C6.95801 4.21663 6.86634 4.12496 6.74967 4.12496Z"
        fill="currentColor"
      />
      <path
        d="M10.0417 6.04168C9.46667 6.04168 9 5.57501 9 5.00001C9 4.42501 9.46667 3.95834 10.0417 3.95834C10.6167 3.95834 11.0833 4.42501 11.0833 5.00001C11.0833 5.57501 10.6167 6.04168 10.0417 6.04168ZM10.0417 4.79168C9.925 4.79168 9.83333 4.88334 9.83333 5.00001C9.83333 5.23334 10.25 5.23334 10.25 5.00001C10.25 4.88334 10.1583 4.79168 10.0417 4.79168Z"
        fill="currentColor"
      />
      <path
        d="M13.2507 16.875C12.6757 16.875 12.209 16.4083 12.209 15.8333C12.209 15.2583 12.6757 14.7917 13.2507 14.7917C13.8257 14.7917 14.2923 15.2583 14.2923 15.8333C14.2923 16.4083 13.8257 16.875 13.2507 16.875ZM13.2507 15.625C13.134 15.625 13.0423 15.7167 13.0423 15.8333C13.0423 16.0667 13.459 16.0667 13.459 15.8333C13.459 15.7167 13.3673 15.625 13.2507 15.625Z"
        fill="currentColor"
      />
      <path
        d="M6.74967 16.875C6.17467 16.875 5.70801 16.4083 5.70801 15.8333C5.70801 15.2583 6.17467 14.7917 6.74967 14.7917C7.32467 14.7917 7.79134 15.2583 7.79134 15.8333C7.79134 16.4083 7.32467 16.875 6.74967 16.875ZM6.74967 15.625C6.63301 15.625 6.54134 15.7167 6.54134 15.8333C6.54134 16.0667 6.95801 16.0667 6.95801 15.8333C6.95801 15.7167 6.86634 15.625 6.74967 15.625Z"
        fill="currentColor"
      />
      <path
        d="M10.0417 16.2083C9.46667 16.2083 9 15.7417 9 15.1667C9 14.5917 9.46667 14.125 10.0417 14.125C10.6167 14.125 11.0833 14.5917 11.0833 15.1667C11.0833 15.7417 10.6167 16.2083 10.0417 16.2083ZM10.0417 14.9583C9.925 14.9583 9.83333 15.05 9.83333 15.1667C9.83333 15.4 10.25 15.4 10.25 15.1667C10.25 15.05 10.1583 14.9583 10.0417 14.9583Z"
        fill="currentColor"
      />
      <path
        d="M7.08301 11.25C6.39134 11.25 5.83301 10.6917 5.83301 10C5.83301 9.30833 6.39134 8.75 7.08301 8.75C7.77467 8.75 8.33301 9.30833 8.33301 10C8.33301 10.6917 7.77467 11.25 7.08301 11.25ZM7.08301 9.58333C6.84967 9.58333 6.66634 9.76667 6.66634 10C6.66634 10.2333 6.84967 10.4167 7.08301 10.4167C7.31634 10.4167 7.49967 10.2333 7.49967 10C7.49967 9.76667 7.31634 9.58333 7.08301 9.58333Z"
        fill="currentColor"
      />
      <path
        d="M8.54199 13.75C7.85033 13.75 7.29199 13.1917 7.29199 12.5C7.29199 11.8083 7.85033 11.25 8.54199 11.25C9.23366 11.25 9.79199 11.8083 9.79199 12.5C9.79199 13.1917 9.23366 13.75 8.54199 13.75ZM8.54199 12.0833C8.30866 12.0833 8.12533 12.2667 8.12533 12.5C8.12533 12.7333 8.30866 12.9167 8.54199 12.9167C8.77533 12.9167 8.95866 12.7333 8.95866 12.5C8.95866 12.2667 8.77533 12.0833 8.54199 12.0833Z"
        fill="currentColor"
      />
      <path
        d="M11.458 13.75C10.7663 13.75 10.208 13.1917 10.208 12.5C10.208 11.8083 10.7663 11.25 11.458 11.25C12.1497 11.25 12.708 11.8083 12.708 12.5C12.708 13.1917 12.1497 13.75 11.458 13.75ZM11.458 12.0833C11.2247 12.0833 11.0413 12.2667 11.0413 12.5C11.0413 12.7333 11.2247 12.9167 11.458 12.9167C11.6913 12.9167 11.8747 12.7333 11.8747 12.5C11.8747 12.2667 11.6913 12.0833 11.458 12.0833Z"
        fill="currentColor"
      />
      <path
        d="M9.99988 2.87495C9.53321 2.87495 9.1582 2.49995 9.1582 2.04162C9.1582 1.58328 9.5332 1.20828 9.99154 1.20828C10.4499 1.20828 10.8249 1.58328 10.8249 2.04162C10.8249 2.49995 10.4665 2.87495 9.99988 2.87495Z"
        fill="currentColor"
      />
      <path
        d="M14.3755 3.00009C14.0255 3.00009 13.7422 2.71676 13.7422 2.37509C13.7422 2.03342 14.0255 1.75009 14.3672 1.75009C14.7089 1.75009 15.0005 2.03342 15.0005 2.37509C15.0005 2.71676 14.7255 3.00009 14.3755 3.00009Z"
        fill="currentColor"
      />
      <path
        d="M5.625 3C5.28333 3 5 2.71667 5 2.375C5 2.03333 5.275 1.75 5.625 1.75H5.63334C5.97501 1.75 6.25834 2.03333 6.25834 2.375C6.25834 2.71667 5.975 3 5.625 3Z"
        fill="currentColor"
      />
      <path
        d="M9.99988 18.75C9.53321 18.75 9.1582 18.375 9.1582 17.9167C9.1582 17.4583 9.5332 17.0833 9.99154 17.0833C10.4499 17.0833 10.8249 17.4583 10.8249 17.9167C10.8249 18.375 10.4665 18.75 9.99988 18.75Z"
        fill="currentColor"
      />
      <path
        d="M14.3755 18.2084C14.0255 18.2084 13.7422 17.9251 13.7422 17.5834C13.7422 17.2417 14.0255 16.9584 14.3672 16.9584C14.7089 16.9584 15.0005 17.2417 15.0005 17.5834C15.0005 17.9251 14.7255 18.2084 14.3755 18.2084Z"
        fill="currentColor"
      />
      <path
        d="M5.625 18.2083C5.28333 18.2083 5 17.925 5 17.5833C5 17.2417 5.275 16.9583 5.625 16.9583H5.63334C5.97501 16.9583 6.25834 17.2417 6.25834 17.5833C6.25834 17.925 5.975 18.2083 5.625 18.2083Z"
        fill="currentColor"
      />
      <path
        d="M1.29134 10.8333C0.833008 10.8333 0.458008 10.4667 0.458008 9.99999C0.458008 9.54166 0.833008 9.16666 1.29134 9.16666C1.74967 9.16666 2.12467 9.54166 2.12467 9.99999C2.12467 10.4583 1.74967 10.8333 1.29134 10.8333Z"
        fill="currentColor"
      />
      <path
        d="M3.125 14.7917C2.78333 14.7917 2.5 14.5167 2.5 14.1667V14.1583C2.5 13.8167 2.78333 13.5333 3.125 13.5333C3.46667 13.5333 3.75 13.8167 3.75 14.1583C3.75 14.5 3.46667 14.7917 3.125 14.7917Z"
        fill="currentColor"
      />
      <path
        d="M3.125 6.46667C2.78333 6.46667 2.5 6.18334 2.5 5.84167C2.5 5.50001 2.78333 5.21667 3.125 5.21667C3.46667 5.21667 3.75 5.49167 3.75 5.83334V5.84167C3.75 6.18334 3.46667 6.46667 3.125 6.46667Z"
        fill="currentColor"
      />
      <path
        d="M18.7503 10.8333C18.292 10.8333 17.917 10.4667 17.917 9.99999C17.917 9.54166 18.292 9.16666 18.7503 9.16666C19.2087 9.16666 19.5837 9.54166 19.5837 9.99999C19.5837 10.4583 19.2087 10.8333 18.7503 10.8333Z"
        fill="currentColor"
      />
      <path
        d="M16.917 14.7917C16.5753 14.7917 16.292 14.5167 16.292 14.1667V14.1583C16.292 13.8167 16.5753 13.5333 16.917 13.5333C17.2587 13.5333 17.542 13.8167 17.542 14.1583C17.542 14.5 17.2587 14.7917 16.917 14.7917Z"
        fill="currentColor"
      />
      <path
        d="M16.917 6.46667C16.5753 6.46667 16.292 6.18334 16.292 5.84167C16.292 5.50001 16.5753 5.21667 16.917 5.21667C17.2587 5.21667 17.542 5.49167 17.542 5.84167V5.85001C17.542 6.18334 17.2587 6.46667 16.917 6.46667Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ImprovementIcon({ size = 20 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5089 1.84166C10.2089 1.60832 9.79226 1.60832 9.49226 1.84166C7.90892 3.04999 3.23389 6.99166 3.25889 11.5833C3.25889 15.3 6.28392 18.3333 10.0089 18.3333C13.7339 18.3333 16.7589 15.3083 16.7589 11.5917C16.7672 7.06666 12.0839 3.05832 10.5089 1.84166Z"
        stroke="currentColor"
        stroke-miterlimit="10"
      />
      <path
        d="M10 15.8L16.4167 12.6833"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 11.6333L16.1417 8.64999"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 7.46665L14.1917 5.42499"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function FeatureIcon({ size = 20 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.74972 7.58332L9.74972 5.83332C9.91639 5.74999 10.0831 5.74999 10.3331 5.83332L14.3331 7.58332C14.6664 7.74999 14.9997 7.33332 14.7497 6.99999L10.5831 1.91666C10.3331 1.58332 9.83306 1.58332 9.58306 1.91666L5.41639 6.99999C5.08306 7.33332 5.41639 7.74999 5.74972 7.58332Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.74972 12.4167L9.74972 14.1667C9.91639 14.25 10.0831 14.25 10.3331 14.1667L14.3331 12.4167C14.6664 12.25 14.9997 12.6667 14.7497 13L10.5831 18.0834C10.3331 18.4167 9.83306 18.4167 9.58306 18.0834L5.41639 13C5.08306 12.6667 5.41639 12.25 5.74972 12.4167Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0003 7.83334L5.66699 10L10.0003 12.1667L14.3337 10L10.0003 7.83334Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function RedesignIcon({ size = 20 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.91719 17.0833C3.60885 17.775 4.72552 17.775 5.41719 17.0833L16.2505 6.25001C16.9422 5.55835 16.9422 4.44168 16.2505 3.75001C15.5589 3.05835 14.4422 3.05835 13.7505 3.75001L2.91719 14.5833C2.22552 15.275 2.22552 16.3917 2.91719 17.0833Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.08301 2.03332L8.33301 1.66666L7.96634 2.91666L8.33301 4.16666L7.08301 3.79999L5.83301 4.16666L6.19967 2.91666L5.83301 1.66666L7.08301 2.03332Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 7.03332L5 6.66666L4.63333 7.91666L5 9.16666L3.75 8.79999L2.5 9.16666L2.86667 7.91666L2.5 6.66666L3.75 7.03332Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.25 11.2L17.5 10.8333L17.1333 12.0833L17.5 13.3333L16.25 12.9667L15 13.3333L15.3667 12.0833L15 10.8333L16.25 11.2Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function CleanupIcon({ size = 20 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.91745 15.0334V14.0667C5.00078 12.9084 3.42578 10.6501 3.42578 8.25006C3.42578 4.12506 7.21745 0.891732 11.5008 1.82506C13.3841 2.24173 15.0341 3.49173 15.8924 5.21673C17.6341 8.71673 15.8008 12.4334 13.1091 14.0584V15.0251C13.1091 15.2667 13.2008 15.8251 12.3091 15.8251H7.71745C6.80078 15.8334 6.91745 15.4751 6.91745 15.0334Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.08301 18.3333C8.99134 17.7916 11.008 17.7916 12.9163 18.3333Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ActiveProjectsIcon({ size = 16 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33398 10.6666C9.33398 11.8466 8.82065 12.9133 8.00065 13.64C7.29398 14.28 6.36065 14.6666 5.33398 14.6666C3.12732 14.6666 1.33398 12.8733 1.33398 10.6666C1.33398 8.82664 2.58732 7.26664 4.28065 6.80664C4.74065 7.96664 5.72732 8.85997 6.94732 9.19331C7.28065 9.28664 7.63398 9.33331 8.00065 9.33331C8.36732 9.33331 8.72065 9.28664 9.05398 9.19331C9.23398 9.64664 9.33398 10.1466 9.33398 10.6666Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 5.3335C12 5.8535 11.9 6.3535 11.72 6.80683C11.26 7.96683 10.2733 8.86016 9.05333 9.1935C8.72 9.28683 8.36667 9.3335 8 9.3335C7.63333 9.3335 7.28 9.28683 6.94667 9.1935C5.72667 8.86016 4.74 7.96683 4.28 6.80683C4.1 6.3535 4 5.8535 4 5.3335C4 3.12683 5.79333 1.3335 8 1.3335C10.2067 1.3335 12 3.12683 12 5.3335Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6667 10.6666C14.6667 12.8733 12.8733 14.6666 10.6667 14.6666C9.64 14.6666 8.70667 14.28 8 13.64C8.82 12.9133 9.33333 11.8466 9.33333 10.6666C9.33333 10.1466 9.23333 9.64664 9.05333 9.19331C10.2733 8.85997 11.26 7.96664 11.72 6.80664C13.4133 7.26664 14.6667 8.82664 14.6667 10.6666Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function Eye({ size = 16 }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M17.7087 7.62506C15.7837 4.60006 12.967 2.8584 10.0003 2.8584C8.51699 2.8584 7.07533 3.29173 5.75866 4.10007C4.44199 4.91673 3.25866 6.1084 2.29199 7.62506C1.45866 8.9334 1.45866 11.0584 2.29199 12.3667C4.21699 15.4001 7.03366 17.1334 10.0003 17.1334C11.4837 17.1334 12.9253 16.7001 14.242 15.8917C15.5587 15.0751 16.742 13.8834 17.7087 12.3667C18.542 11.0667 18.542 8.9334 17.7087 7.62506ZM10.0003 13.3667C8.13366 13.3667 6.63366 11.8584 6.63366 10.0001C6.63366 8.14173 8.13366 6.6334 10.0003 6.6334C11.867 6.6334 13.367 8.14173 13.367 10.0001C13.367 11.8584 11.867 13.3667 10.0003 13.3667Z"
        fill="currentColor"
      />
      <path
        d="M10 7.61621C8.69167 7.61621 7.625 8.68288 7.625 9.99954C7.625 11.3079 8.69167 12.3745 10 12.3745C11.3083 12.3745 12.3833 11.3079 12.3833 9.99954C12.3833 8.69121 11.3083 7.61621 10 7.61621Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function WorkloadIcon({ size }: SizeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.46635 12.5002H2.76636C1.53969 12.5002 0.833008 11.7935 0.833008 10.5668V2.76684C0.833008 1.54018 1.53969 0.833496 2.76636 0.833496H5.63301C6.85968 0.833496 7.56632 1.54018 7.56632 2.76684V4.00016C7.56632 4.27349 7.33965 4.50016 7.06632 4.50016C6.79299 4.50016 6.56632 4.27349 6.56632 4.00016V2.76684C6.56632 2.08685 6.31301 1.8335 5.63301 1.8335H2.76636C2.08636 1.8335 1.83301 2.08685 1.83301 2.76684V10.5668C1.83301 11.2468 2.08636 11.5002 2.76636 11.5002H4.46635C4.73968 11.5002 4.96635 11.7268 4.96635 12.0002C4.96635 12.2735 4.73968 12.5002 4.46635 12.5002Z"
        fill="currentColor"
      />
      <path
        d="M9.97347 15.1667H6.08012C4.74012 15.1667 3.9668 14.3933 3.9668 13.0533V5.61332C3.9668 4.27332 4.74012 3.5 6.08012 3.5H9.97347C11.3135 3.5 12.0801 4.27332 12.0801 5.61332V13.0533C12.0801 14.3933 11.3135 15.1667 9.97347 15.1667ZM6.08012 4.5C5.28012 4.5 4.9668 4.81332 4.9668 5.61332V13.0533C4.9668 13.8533 5.28012 14.1667 6.08012 14.1667H9.97347C10.7668 14.1667 11.0801 13.8533 11.0801 13.0533V5.61332C11.0801 4.81332 10.7668 4.5 9.97347 4.5H6.08012Z"
        fill="currentColor"
      />
      <path
        d="M13.2336 12.5002H11.5802C11.3069 12.5002 11.0802 12.2735 11.0802 12.0002C11.0802 11.7268 11.3069 11.5002 11.5802 11.5002H13.2336C13.9136 11.5002 14.1669 11.2468 14.1669 10.5668V2.76684C14.1669 2.08685 13.9136 1.8335 13.2336 1.8335H10.3669C9.6869 1.8335 9.43359 2.08685 9.43359 2.76684V4.00016C9.43359 4.27349 9.20693 4.50016 8.93359 4.50016C8.66026 4.50016 8.43359 4.27349 8.43359 4.00016V2.76684C8.43359 1.54018 9.14024 0.833496 10.3669 0.833496H13.2336C14.4602 0.833496 15.1669 1.54018 15.1669 2.76684V10.5668C15.1669 11.7935 14.4602 12.5002 13.2336 12.5002Z"
        fill="currentColor"
      />
      <path
        d="M9.33366 7.8335H6.66699C6.39366 7.8335 6.16699 7.60683 6.16699 7.3335C6.16699 7.06016 6.39366 6.8335 6.66699 6.8335H9.33366C9.60699 6.8335 9.83366 7.06016 9.83366 7.3335C9.83366 7.60683 9.60699 7.8335 9.33366 7.8335Z"
        fill="currentColor"
      />
      <path
        d="M9.33366 9.8335H6.66699C6.39366 9.8335 6.16699 9.60683 6.16699 9.3335C6.16699 9.06016 6.39366 8.8335 6.66699 8.8335H9.33366C9.60699 8.8335 9.83366 9.06016 9.83366 9.3335C9.83366 9.60683 9.60699 9.8335 9.33366 9.8335Z"
        fill="currentColor"
      />
      <path
        d="M8 15.1665C7.72667 15.1665 7.5 14.9398 7.5 14.6665V12.6665C7.5 12.3932 7.72667 12.1665 8 12.1665C8.27333 12.1665 8.5 12.3932 8.5 12.6665V14.6665C8.5 14.9398 8.27333 15.1665 8 15.1665Z"
        fill="currentColor"
      />
    </svg>
  );
}
